import React from 'react';

const VerificationListSkeleton = ({ count = 8 }) => {
	return (
		<>
			{Array.from({ length: count }).map((_, idx) => (
				<div className="col-xl-3 col-xxl-4 col-lg-4 col-sm-6" key={idx}>
					<div className="card user-card">
						<div className="card-body pb-0">
							<div className="d-flex mb-3 align-items-center">
								<div className="dz-media me-3">
									<div className="skeleton" style={{ width: 50, height: 50, borderRadius: 8, background: '#eee' }} />
								</div>
								<div className="flex-grow-1">
									<div className="skeleton" style={{ width: 120, height: 20, borderRadius: 4, marginBottom: 8, background: '#eee' }} />
									<div className="skeleton" style={{ width: 80, height: 16, borderRadius: 4, background: '#eee' }} />
								</div>
							</div>
							<div className="skeleton" style={{ width: '100%', height: 40, borderRadius: 4, marginBottom: 16, background: '#eee' }} />
							<ul className="list-group list-group-flush">
								<li className="list-group-item">
									<div className="skeleton" style={{ width: '100%', height: 16, borderRadius: 4, background: '#eee' }} />
								</li>
								<li className="list-group-item">
									<div className="skeleton" style={{ width: '80%', height: 16, borderRadius: 4, background: '#eee' }} />
								</li>
								<li className="list-group-item">
									<div className="skeleton" style={{ width: '90%', height: 16, borderRadius: 4, background: '#eee' }} />
								</li>
								<li className="list-group-item">
									<div className="skeleton" style={{ width: '70%', height: 16, borderRadius: 4, background: '#eee' }} />
								</li>
								<li className="list-group-item">
									<div className="skeleton" style={{ width: '60%', height: 16, borderRadius: 4, background: '#eee' }} />
								</li>
							</ul>
						</div>
						<div className="card-footer">
							<div className="d-flex flex-wrap gap-1">
								<div className="skeleton" style={{ width: 80, height: 32, borderRadius: 4, background: '#eee' }} />
								<div className="skeleton" style={{ width: 100, height: 32, borderRadius: 4, background: '#eee' }} />
							</div>
						</div>
					</div>
				</div>
			))}
		</>
	);
};

export default VerificationListSkeleton;